export default __webpack_public_path__ + "img/1f31020997d307ece8adb98480354448.png";